import { Component, Input, OnInit } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PatientMedicalHistoryService } from '../../adminside-patients/admin-patient-medical-history/patient-medical-history.service';

export interface PatientMedicalHistoryDataset {
    owner_id: string;
    company_id: string;
    is_deleted: boolean;
    header: string;
    rows: {
      data_type: string,
      value: string,
    }[];
}
export interface PatientMedicalHistory {
  patient_id: string;
  selected_data: {
    group_id: string;
    items: string[]
  }[]
}
@Component({
  selector: 'app-patient-medical-history',
  templateUrl: './patient-medical-history.component.html',
  styleUrls: ['./patient-medical-history.component.css']
})
export class PatientMedicalHistoryComponent implements OnInit {
  @Input() patient:any;

  patientMedicalHistory: PatientMedicalHistory;
  patientMedicalHistoryDataset: PatientMedicalHistoryDataset;

  constructor(
    private _patientMedicalHistoryService:PatientMedicalHistoryService
  ) { }

  ngOnInit(): void {
      this.initPatientMedicalHistorySelectedData();
      this.initPatientMedicalHistoryDataset();
  }

  async initPatientMedicalHistorySelectedData() {
    const {data, status} = await lastValueFrom(this._patientMedicalHistoryService.getPatientMedicalHistory(this.patient._id)) as any;
    if (status == 200) {
      if(data) {
        this.patientMedicalHistory = data;
      } else {
        this.patientMedicalHistory = {
          patient_id: this.patient._id,
          selected_data: []
        }
      }
    }
  }
  async initPatientMedicalHistoryDataset() {
    const {data, status} = await lastValueFrom(this._patientMedicalHistoryService.getAllDatasetinCompany()) as any;
    if (status == 200) {
      this.patientMedicalHistoryDataset = data;
    }
  }

  isSelectedItem(group_id: string, item: string) {
    const group = this.patientMedicalHistory?.selected_data?.find(x => x.group_id == group_id);
    if(group) {
      return group.items.includes(item);
    } else {
      return false;
    }
  }

  selectItem(group_id: string, item: string) {
    const group = this.patientMedicalHistory?.selected_data?.find(x => x.group_id == group_id);
    if(group) {
      let index = group.items.indexOf(item);
      if(index === -1) {
        group.items.push(item);
        // group.items = [item];
      } else {
        group.items.splice(index, 1);
      }
    } else {
      this.patientMedicalHistory.selected_data.push({
        group_id: group_id,
        items: [item]
      });
    }
    this.updatePatientMedicalHistory(this.patientMedicalHistory.selected_data);
  }

  async updatePatientMedicalHistory(selected_data) {
    let {data, status} = await lastValueFrom(this._patientMedicalHistoryService.updatePatientMedicalHistory(this.patient._id, selected_data)) as any;
    if (status == 200) {
      console.log('updated');
    }
  }
}
